import Hourglass from "../../images/Hourglass.gif"
import "./Loader.css"

export const Loader = () =>{
    return (
        <img src={Hourglass} id="preloader" alt="Hourglass" />
    )
}